"use client";
import React, { ReactNode } from "react";
import { ParallaxProvider } from "react-scroll-parallax";

export default function ParallaxClientProvider({
  children,
}: {
  children: ReactNode;
}) {
  return <ParallaxProvider>{children}</ParallaxProvider>;
}
